"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_class_component_1 = __importDefault(require("vue-class-component"));
var vue_property_decorator_1 = require("vue-property-decorator");
var VIcon_vue_1 = __importDefault(require("./VIcon.vue"));
var __ = window.$lang;
var icons = {
    "paid": "fas fa-check",
    "unpaid": "fas fa-times",
    "not-applicable": "fas fa-minus",
    "out-of-range": "fas"
};
var colors = {
    "paid": "success",
    "unpaid": "danger",
    "not-applicable": "black",
    "out-of-range": ""
};
var titles = {
    "paid": __("Składka opłacona"),
    "unpaid": __("Składka nieopłacona"),
    "not-applicable": __("Nie dotyczy"),
    "out-of-range": ""
};
var VSimpleContributionStatus = /** @class */ (function (_super) {
    __extends(VSimpleContributionStatus, _super);
    function VSimpleContributionStatus() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "v-simple-contribution-status";
        return _this;
    }
    Object.defineProperty(VSimpleContributionStatus.prototype, "icon", {
        get: function () {
            return icons[this.status];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VSimpleContributionStatus.prototype, "color", {
        get: function () {
            return colors[this.status];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VSimpleContributionStatus.prototype, "title", {
        get: function () {
            return titles[this.status];
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], VSimpleContributionStatus.prototype, "status", void 0);
    VSimpleContributionStatus = __decorate([
        vue_class_component_1.default({ components: {
                VIcon: VIcon_vue_1.default
            } })
    ], VSimpleContributionStatus);
    return VSimpleContributionStatus;
}(vue_property_decorator_1.Vue));
exports.default = VSimpleContributionStatus;
